if (!customElements.get('ac-refined-faq')) {
  customElements.define('ac-refined-faq', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const search = this.querySelector('[data-faq-search]');
      const input = this.querySelector('input[type="search"]');
      const status = this.querySelector('[data-faq-status]');
      const empty = this.querySelector('[data-faq-empty]');
      const items = Array.from(this.querySelectorAll('[data-faq-item]'));
      const groups = Array.from(this.querySelectorAll('[data-faq-group]'));
      if (!search || !input || !status || !empty) return;
      search.hidden = false;
      input.addEventListener('input', () => {
        const terms = input.value.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
        let count = 0;
        items.forEach(item => {
          const text = item.textContent.toLocaleLowerCase();
          const matches = terms.every(term => text.includes(term));
          item.hidden = !matches;
          if (matches) count += 1;
        });
        groups.forEach(group => {
          group.hidden = !Array.from(group.querySelectorAll('[data-faq-item]')).some(item => !item.hidden);
        });
        empty.hidden = count > 0;
        status.textContent = terms.length ? `${count} ${count === 1 ? 'answer' : 'answers'} found` : '';
      });
    }
  });
}
